import { render, staticRenderFns } from "./LavorazioneDettaglio.vue?vue&type=template&id=2d2f190b&scoped=true"
import script from "./LavorazioneDettaglio.vue?vue&type=script&lang=ts"
export * from "./LavorazioneDettaglio.vue?vue&type=script&lang=ts"
import style0 from "./LavorazioneDettaglio.vue?vue&type=style&index=0&id=2d2f190b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f190b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2f190b')) {
      api.createRecord('2d2f190b', component.options)
    } else {
      api.reload('2d2f190b', component.options)
    }
    module.hot.accept("./LavorazioneDettaglio.vue?vue&type=template&id=2d2f190b&scoped=true", function () {
      api.rerender('2d2f190b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LavorazioneDettaglio.vue"
export default component.exports